<template>
  <div>
    <div v-if="!onetime">
      <div class="w-32 mx-auto pt-14">
        <logo-black :width="'w-32'" :height="'h-12'"></logo-black>
      </div>
      <div class="pt-7">
        <div class="text-2xl font-extrabold">Welcome</div>
      </div>
      <div class="text-left px-6">
        <div class="pt-6">
          <div class="text-xs">Please register with your phone number</div>
        </div>
        <div class="pt-6">
          <input-text type="text" v-model="phone" placeholder="Phone"></input-text>
          <span class="text-xs">e.g +2349077877777 and not +23409077877777</span>
        </div>
        <div class="pt-7 text-xs">
          <button
            id="sign-in-button"
            pattern="\+[0-9\s\-\(\)]+"
            type="submit"
            class="
              w-full
              inline-block
              text-center
              py-4
              cursor-pointer
              font-medium
              rounded
              bg-nw-red
              hover:bg-red-600
              text-white
              focus:outline-none
            "
          >
            CONTINUE
          </button>
        </div>
      </div>
    </div>
    <one-time v-if="onetime" :verificationId="verificationId"></one-time>
    <div class="fixed left-0 top-0 w-full bg-dark-transparent h-screen" v-if="loading">
      <div class="absolute top-2/4 w-full">
        <loading :width="'w-10'" :height="'h-10'"></loading>
      </div>
    </div>
  </div>
</template>

<script>
import LogoBlack from '../../components/icons/LogoBlack.vue'
import InputText from '../../components/inputs/InputText.vue'
import OneTime from '../../components/OneTime.vue'
import Swal from 'sweetalert2'
import fb from '@/services/firebase.js'
import Loading from '../../components/icons/Loading.vue'

export default {
  components: { LogoBlack, InputText, OneTime, Loading },
  data() {
    return {
      onetime: false,
      phone: '+234',
      verificationId: '',
      loading: false
    }
  },
  methods: {
    signIn() {
      this.$router.push({
        name: 'Login'
      })
    },
    runRecaptcha() {
      window.recaptchaVerifier = new fb.recapt('sign-in-button', {
        size: 'invisible',
        callback: response => {
          // reCAPTCHA solved, allow signInWithPhoneNumber.
          console.log(response)
          this.getCode()
        }
      })

      window.recaptchaVerifier.render().then(widgetId => {
        window.recaptchaWidgetId = widgetId
      })
    },
    getCode() {
      if (this.phone != '' && this.phone != '+234') {
        this.loading = true
        const appVerifier = window.recaptchaVerifier
        fb.auth
          .signInWithPhoneNumber(this.phone, appVerifier)
          .then(confirmationResult => {
            // SMS sent. Prompt user to type the code from the message, then sign the
            // user in with confirmationResult.confirm(code).
            this.verificationId = confirmationResult.verificationId
            this.onetime = true
            this.loading = false
            Swal.fire('Success', 'An SMS has been sent to ' + this.phone, 'success')
          })
          .catch(error => {
            //Swal.fire('Error', error, 'error')
            console.log(error)
          })
      } else {
        Swal.fire('', 'Input Phone Number')
      }
    }
  },
  mounted() {
    this.runRecaptcha()
    this.$store.dispatch('middleware/isLoggedIn')
  }
}
</script>
